import React, { useState } from 'react';
import { Button } from 'components/common';
import { renderParagraph, renderImage } from 'components/utils/render';
import { formatVideoUrl } from 'components/utils';
import PlayFillIcon from 'remixicon-react/PlayFillIcon';
import { Container, Media, Image, Video, Play, VideoContainer, Content, Title, Description  } from './HeroBanner.style';

interface Props {
    title: string;
    description: string;
    ctaButton: any;
    isVideo: boolean;
    image: string;
    video: any;
}

const HeroBanner: React.FC<Props> = ({ title, description, ctaButton, isVideo = false, image, video }) => {
    
    const [playVideo, setPlayVideo] = useState(false);

    return (
       <Container>
            {(image || video) &&
                <Media>
                    { isVideo ?
                        <Video onClick={() => setPlayVideo(!playVideo)}>
                            {
                                playVideo ?
                                <VideoContainer src={formatVideoUrl(video.videoURL)} allow='autoplay'/> :
                                <React.Fragment>
                                    {renderImage(video)}
                                    <Play><PlayFillIcon /></Play>
                                </React.Fragment>
                            }
                        </Video> :
                        <Image>{renderImage(image)}</Image>
                    }
                </Media>
            }
            <Content>
                <Title>{title}</Title>
                <Description>{renderParagraph(description)}</Description>
                {ctaButton && ctaButton.btnText && <Button {...ctaButton}/>}
            </Content>
       </Container>
    );
};

export default HeroBanner;